import { Tooltip, TooltipTrigger, WithNAFallback } from '@toggle/design-system';
import { getPriceStatus } from '@toggle/helpers';
import { Entity, mapEntity } from '@toggle/toggle';
import React from 'react';

import { PriceCellTooltip } from '~/components/price-cell/price-cell-tooltip/PriceCellTooltip';
import { getPriceStamp } from '~/components/price-display-view/helpers/price-display-helpers';
import { useOneDayReturnLivePrice } from '~/hooks/use-one-day-return-live-price/useOneDayReturnLivePrice';
import { formatPercentageNumber } from '~/widgets/earnings/utils/utils';

import * as S from './RevampCompetitorsSection.styles';

export interface ChangeCellProps {
  entity: Entity;
}

export const ChangeCell = ({ entity }: ChangeCellProps) => {
  const {
    oneDayLiveReturn,
    isSubscribing,
    date,
    isLive,
    isLivePriceSupported,
  } = useOneDayReturnLivePrice(mapEntity(entity));

  if (isSubscribing) {
    return <S.StyledSkeletonLoader />;
  }

  const status = getPriceStatus(oneDayLiveReturn);
  const stamp = getPriceStamp({
    isLivePriceSupported,
    isLive,
    isDisabled: false,
  });

  return (
    <S.ChangeRow>
      <WithNAFallback
        check={oneDayLiveReturn !== undefined}
        value={
          <Tooltip
            isTouchDevice={false}
            trigger={TooltipTrigger.Hover}
            label={
              date && <PriceCellTooltip type={stamp.stampType} date={date} />
            }
            inPortal
            disabled={!date}
          >
            <S.ChangeValue $status={status}>
              {formatPercentageNumber({
                value: oneDayLiveReturn,
                includePercentSign: true,
                addPlus: true,
              })}
            </S.ChangeValue>
          </Tooltip>
        }
      />
    </S.ChangeRow>
  );
};
